import { createFileRoute } from '@tanstack/react-router';
import ObjectTypePage from '@/pages/workspaces/objects/object-type.page';
import { ObjectsMigrationRoute } from '@/pages/workspaces/objects/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/')({
  component: () => (
    <ObjectsMigrationRoute>
      <ObjectTypePage />
    </ObjectsMigrationRoute>
  ),
});
